import React from 'react';
import { CRMProvider } from '../contexts/CRMContext';
import { EstimatesProvider } from '../contexts/EstimatesContext';
import { ProjectsProvider } from '../contexts/ProjectsContext';
import { FleetProvider } from '../contexts/FleetContext';
import { TimeClockProvider } from '../contexts/TimeClockContext';
import { useLeadProposalAutoConvert } from '../hooks/useLeadProposalConversion';

/**
 * Pasa a cliente el prospecto cuya propuesta se firmó desde el enlace público.
 *
 * Vive aquí, y como componente aparte, porque necesita leer los DOS lados —
 * prospectos (CRM) y propuestas (Estimates)— y por tanto tiene que colgar por
 * debajo de ambos proveedores. No pinta nada.
 */
const LeadProposalAutoConvert: React.FC = () => {
    useLeadProposalAutoConvert();
    return null;
};

/**
 * DataProviders — Flat composition of all data-layer context providers.
 *
 * These providers are independent of each other (no cross-dependencies),
 * so they can be composed in any order. This component eliminates the
 * "Context Pyramid of Doom" that previously existed in App.tsx.
 *
 * NOTE: SettingsProvider remains separate because it MUST be mounted
 * before any data provider (pricing engine / overhead metrics).
 */
const DataProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <CRMProvider>
        <EstimatesProvider>
            <LeadProposalAutoConvert />
            <ProjectsProvider>
                <FleetProvider>
                    <TimeClockProvider>
                        {children}
                    </TimeClockProvider>
                </FleetProvider>
            </ProjectsProvider>
        </EstimatesProvider>
    </CRMProvider>
);

export default DataProviders;

